import { Button, Text as FreshText } from '@fhs/ui';
import { Box, Text } from '@fhs-legacy/universal-components';
import { IRestaurantNode } from 'generated/rbi-graphql';

const SuggestionBox = Box.withConfig({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  paddingY: 2,
});

const InnerBox = Box.withConfig({
  flex: 1,
  display: 'flex',
  alignItems: 'start',
  alignContent: 'start',
  flexDirection: 'column',
  justifyItems: 'start',
  justifyContent: 'center',
});

const ButtonBox = Box.withConfig({
  display: 'flex',
});

export const PickUpAt = Text.withConfig({
  textAlign: 'left',

  fontSize: 'xs',
  lineHeight: 'xs',
  fontFamily: 'body',
});

export const DistanceAndAddress = Text.withConfig({
  ellipsizeMode: 'tail',
  numberOfLines: 1,
  textAlign: 'left',

  fontSize: 'xs',
  lineHeight: 'xs',
  fontFamily: 'body',
});

export type AddressBoxSuggestionProps = {
  pickStoreAction: () => void;
  distance: string;
  restaurant: IRestaurantNode;
};

export const AddressBoxSuggestion: React.FC<React.PropsWithChildren<AddressBoxSuggestionProps>> = ({
  pickStoreAction,
  distance,
  restaurant,
}) => {
  const storeName = restaurant?.name ?? '';

  const getAddress = (store: IRestaurantNode) => {
    const addressFields = ['address1', 'address2', 'city', 'state', 'country', 'zip'];
    const addressField = store.physicalAddress ?? {};

    return addressFields
      .map(field => addressField[field])
      .filter(Boolean)
      .join(', ');
  };

  const handleSelectStore = () => {
    pickStoreAction();
  };

  return (
    <SuggestionBox>
      <InnerBox>
        <PickUpAt>Pick Up:</PickUpAt>
        <FreshText.Heading type="four">{storeName}</FreshText.Heading>
        <DistanceAndAddress>{`${distance} · ${getAddress(restaurant)}`}</DistanceAndAddress>
      </InnerBox>
      <ButtonBox>
        <Button
          type="outline"
          size="xs"
          testID={`store-suggestion-select-${storeName}`}
          onPress={handleSelectStore}
        >
          <Button.Text>Select</Button.Text>
        </Button>
      </ButtonBox>
    </SuggestionBox>
  );
};
